import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { Minus, Plus } from '@octopus-do/octopus-storybook/icons'
import React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  btnText: string
  showIndicator: boolean
  onPlus: () => void
  onMinus: () => void
}

export const ZoomButtons = React.forwardRef<HTMLButtonElement, Props>(
  ({ btnText, showIndicator, onPlus, onMinus }, ref) => {
    const { toggle } = DropdownMenu.useTrigger()

    return (
      <div className={css.zoom_buttons}>
        <button
          className={css.button}
          data-testid="zoom-minus"
          onClick={onMinus}
        >
          <Minus />
        </button>

        <div className={css.divider} />

        <button
          ref={ref}
          className={clsJoin(css.button, css.menu_button)}
          data-testid="zoom"
          onPointerDown={toggle}
        >
          <span>{btnText}</span>
          {showIndicator && <div className={css.button_indicator} />}
        </button>

        <div className={css.divider} />

        <button className={css.button} data-testid="zoom-plus" onClick={onPlus}>
          <Plus />
        </button>
      </div>
    )
  }
)
